module.exports = require('./helpers/bundle-url').getBundleURL('85k6C') + "logo-dark.eefe0b7f.svg";